import { Role, ActionType, ActionValue } from '@versita/shared/models';
import { checkPermissions } from '@versita/shared/rbac-utils';
import { useMsal } from '@azure/msal-react';

/**
 * Check if user has permission to perform action
 * Actions can either be the full action string or the action type e.g. Timetable.Read or Timetable.Read.All
 * The first option acts as a convenient way to check both .Self and/or .All
 * You can pass as many actions as you want to check at once
 *
 * @example useHasPermission(Actions.Timetable.Read.All)
 */
export const useHasPermission = (
  ...actionsToCheck: (ActionValue | ActionType)[]
): boolean => {
  const { instance } = useMsal();
  const account = instance?.getActiveAccount();
  if (!account) {
    return false;
  }

  const roles = (account.idTokenClaims?.roles || []) as Role[];
  return checkPermissions(roles, ...actionsToCheck);
};
